module.exports = __webpack_public_path__ + "static/graphicdesign-a2e2a3ea34c2fa48a7b706059da33ed1.jpg";